import React from 'react'
import { Button, CircularProgress, Box, Typography, DialogActions } from '@mui/material'
const CartActions = ({
  cartInv,
  user,
  view,
  setView,
  setErrors,
  termsCheck,
  setTermsError,
  handleErrors,
  loading,
  handleSubmit
}) => {

  const styles = {
    loadingBox: {
      display: 'flex',
      alignItems: 'center'
    }
  }
  return (
    <DialogActions>
      {view === 1 ? (
        <Button
          onClick={() => {
            setView(0)
          }}
          variant='outlined'
        >
          Back to Cart
        </Button>
      ) : (
        <></>
      )}
      {!user._id ? (
        <Button
          variant='contained'
          onClick={() => {
            window.location.pathname = '/login'
          }}
        >
          Sign in to continue checkout
        </Button>
      ) : (
        <>
          {!loading ? (
            <Button
              disabled={cartInv.length === 0}
              variant='contained'
              sx={{ justifySelf: 'flex-end' }}
              onClick={() => {
                if (view === 0) {
                  let errors = handleErrors()
                  if (Object.keys(errors).length === 0) {
                    setView(1)
                  } else {
                    setErrors(errors)
                  }
                } else {
                  if (termsCheck) {
                    handleSubmit()
                  } else {
                    setTermsError(true)
                  }
                }
              }}
            >
              {view === 0 ? 'Proceed to Check Out' : 'Check Out'}
            </Button>
          ) : (
            <Box style={styles.loadingBox}>
              <CircularProgress />
              <Typography>Checking Data</Typography>
            </Box>
          )}
        </>
      )}
    </DialogActions>
  )
}

export default CartActions
